import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
    persist(
        (set) => ({
            user: null,
            token: null,
            isAuthenticated: false,
            login: (userData, token) => {
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(userData));
                set({ user: userData, token: token, isAuthenticated: true });
            },
            // Aggiorna solo alcuni campi dell'utente in sessione (es. dopo il
            // cambio password). Nota: e' un dato di comodo lato client, la
            // verifica vera avviene comunque nel backend a ogni chiamata.
            aggiornaUser: (campi) =>
                set((state) => {
                    if (!state.user) return state;
                    const nuovo = { ...state.user, ...campi };
                    localStorage.setItem('user', JSON.stringify(nuovo));
                    return { user: nuovo };
                }),
            logout: () => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                set({ user: null, token: null, isAuthenticated: false });
            },
        }),
        { name: 'auth-storage' }
    )
);
